import React, { Fragment } from 'react';
import { Layout } from 'antd';
import { CopyrightOutlined } from '@ant-design/icons';

const { Footer } = Layout;
const QupitalFooter = (props) => (
    <Footer style={{ padding: '10px 0px 20px 0px', textAlign: 'center' }} {...props}>
        <Fragment>
            Copyright <CopyrightOutlined /> {new Date().getFullYear()} Qupital Limited
            橋彼道有限公司. All rights reserved.
        </Fragment>
    </Footer>
);
export { QupitalFooter };
